const required = [(value) => !!value || "This is required"];

const attachment = [
  (value) =>
    !value ||
    value.size < 10000000 ||
    "Attachment size should be less than 10 MB!",
];

const ticket = [
  (value) => !value || value.length == 7 || "This is a 6 digit code",
];

const email = [
  (value) => !value || /.+@.+\..+/.test(value) || "Must be a valid email",
];

const phone = [
  (value) =>
    (value && value.length == 13) || "Must be a valid mobile phone number",
];

const password = [
  (value) =>
    (value && value.length >= 8) || "Must be at least 8 characters long",
];

const statement = [
  (value) => !value || value.length <= 300 || "Must not exceed 300 characters",
];

const abstract = [
  (value) => !value || wordCount(value) <= 250 || "Must not exceed 250 words",
];

function wordCount(text) {
  return text.split(" ").length;
}

export {
  required,
  attachment,
  ticket,
  email,
  phone,
  password,
  statement,
  abstract,
};
